export const TICKER_URI = "https://blockchain.info/ticker";
export const CONVERSION_URI_BASE = "https://blockchain.info/tobtc"